export default __webpack_public_path__ + "static/media/hht1_song_19.93a7a64a.png";